<template>
	<div id="user-search">
		<div class="content">
			<input
				type="text"
				class="search"
				v-model="search"
				:placeholder="placeholder"
				@keydown="switchIndex"
				ref="search"
			/>
			<div class="results">
				<div
					v-for="(result, index) in results"
					class="result"
					:class="{ selected: isSelected(index) }"
					:key="result.id"
					@click="userClick(result)"
				>
					<div v-if="result.removed">
						<strike>
							<b>{{ result.name }}&nbsp;</b>
							<span>{{ result.breed.name }}</span>
						</strike>
						<span>&nbsp;<b>Удален</b></span>
					</div>
					<div v-else>
						<b>{{ result.name }}&nbsp;</b>
						<span>{{ result.breed.name }}</span>
					</div>
					<div>
						<span
							>&#8594; {{ result.mainOwner.name }}
							{{ result.mainOwner.phone }}</span
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VLD from '@/utils/validate'
import { API } from '@/config'

export default {
	name: 'PetSearch',
	props: {
		placeholder: {
			type: String,
			default: 'Имя питомца',
		},
		select: {
			type: String,
			default: undefined,
		},
	},
	data() {
		return {
			searching: false,
			search: '',
			results: [],
			resultIndex: 0,
		}
	},
	watch: {
		search(nv) {
			if (nv.length > 2) this.trySearch(nv)
			else this.results = []
		},
	},
	methods: {
		isSelected(index) {
			return this.resultIndex === index
		},
		switchIndex(e) {
			if (e.keyCode === 13) {
				if (!this.results.length) return
				this.userClick(this.results[this.resultIndex])
				return
			}

			if (e.keyCode !== 38 && e.keyCode !== 40) return
			if (this.results.length < 1) return
			if (e.keyCode === 38) {
				if (this.resultIndex === 0)
					return (this.resultIndex = this.results.length - 1)
				this.resultIndex -= 1
			} else if (e.keyCode === 40) {
				if (this.resultIndex === this.results.length - 1)
					return (this.resultIndex = 0)
				this.resultIndex += 1
			}
		},
		async trySearch(search) {
			if (this.searching) return
			if (this.onlyPhone && !/\+?[0-9]+/.test(search)) return

			this.searching = true

			let payload = {
				search: search,
				onlyPhone: this.onlyPhone,
				select: this.select,
			}

			let { data } = await this.$http.post(API.PETS.search, payload)
			this.searching = false
			if (!data || data.err) return this.$notify(data ? data.err : '')

			this.results = data

			this.resultIndex = 0
			this.searching = false
		},
		async userClick(res) {
			if (!res.mainOwner || !res.mainOwner.supportChat) return
			let payload = {
				id: res.id,
				name: res.name,
				kind: res.kind,
				breed: res.breed,
				owner: res.mainOwner,
				chat: res.mainOwner.supportChat,
			}
			this.$emit('selected', payload)

			this.search = ''
			this.results = []
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

#user-search {
	width: 100%;
	display: flex;
	justify-content: center;
}

.content {
	width: 60%;
	max-width: 400px;
	height: auto;
	position: relative;
}

.search {
	width: 100%;
	padding: 15px;
	text-align: center;
	font-size: 16px;
	line-height: 14px;
	border: none;
	border-radius: 12px;
	box-sizing: border-box;
	outline: none;
	background: @grey;
}

.results {
	width: 100%;
	margin-top: 10px;
	background: #fff;
	border-radius: 10px;
	position: absolute;
	z-index: 2;
	box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);

	.result {
		padding: 10px 15px;
		border-radius: 10px;
		cursor: pointer;

		&.notvalid {
			text-decoration: line-through;
		}

		&.selected,
		&:hover {
			background: @accent;
			color: #fff;
		}

		&.selected:hover {
			background: darken(@accent, 5%);
		}

		span {
			opacity: 0.5;
			font-size: 13px;
		}
	}
}
</style>
